var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-loader"},[_c('v-progress-circular',{attrs:{"size":70,"width":7,"color":_vm.color,"indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }